import type { TranslationKeys } from "./en";

export const ar: TranslationKeys = {
  // Navigation
  nav: {
    home: "الرئيسية",
    features: "المميزات",
    pricing: "الأسعار",
    about: "من نحن",
    blog: "المدوّنة",
    download: "تحميل",
    contact: "اتصل بنا",
    signIn: "تسجيل الدخول",
    getStarted: "ابدأ الآن",
    signOut: "تسجيل الخروج",
    settings: "الإعدادات",
    dashboard: "لوحة التحكم",
    back: "رجوع",
  },

  // Common
  common: {
    loading: "جارٍ التحميل...",
    save: "حفظ",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    add: "إضافة",
    search: "بحث",
    filter: "تصفية",
    export: "تصدير",
    import: "استيراد",
    yes: "نعم",
    no: "لا",
    ok: "حسناً",
    close: "إغلاق",
    submit: "إرسال",
    sending: "جارٍ الإرسال...",
    success: "نجاح",
    error: "خطأ",
    warning: "تحذير",
    info: "معلومات",
    confirm: "تأكيد",
    retry: "إعادة المحاولة",
    readMore: "اقرأ المزيد",
    learnMore: "اعرف المزيد",
    viewAll: "عرض الكل",
    seeAll: "مشاهدة الكل",
    noData: "لا توجد بيانات",
    optional: "اختياري",
    required: "مطلوب",
    all: "الكل",
    none: "لا شيء",
    total: "الإجمالي",
    date: "التاريخ",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    address: "العنوان",
    description: "الوصف",
    notes: "ملاحظات",
    status: "الحالة",
    actions: "الإجراءات",
    amount: "المبلغ",
    balance: "الرصيد",
    type: "النوع",
    category: "الفئة",
    price: "السعر",
    quantity: "الكمية",
    subtotal: "المجموع الفرعي",
    tax: "الضريبة",
    discount: "الخصم",
    changesAutoSaved: "يتم حفظ التغييرات تلقائياً",
    free: "مجاني",
    forever: "للأبد",
    copyright: "© 2025 FINO. جميع الحقوق محفوظة.",
    financesAtFingertips: "أموالك في متناول يدك",
  },

  // Home page
  home: {
    heroTag: "وضعان في تطبيق واحد قوي — مجاني 100%",
    heroTitle: "حلك المتكامل",
    heroTitleHighlight: "للمالية والأعمال",
    heroTitleEnd: "التجارية",
    heroDescription: "سواء كنت تتتبع مصاريفك الشخصية أو تدير متجراً كاملاً — FINO يلبي احتياجاتك. دفتر نقدي شخصي أو إدارة مخزون كاملة، كل ذلك في تطبيق واحد.",
    getStartedFree: "ابدأ مجاناً",
    seeAllFeatures: "شاهد جميع المميزات",
    twoModesTitle: "وضعان، تطبيق واحد قوي",
    twoModesDescription: "اختر الوضع المناسب لاحتياجاتك. يمكنك التبديل في أي وقت بنقرة واحدة.",
    cashbookMode: "وضع دفتر النقد",
    cashbookSubtitle: "تتبع المالية الشخصية",
    cashbookDescription: "مثالي للأفراد والمستقلين والأسر الذين يرغبون في تتبع دخلهم ونفقاتهم اليومية دون أي تعقيد.",
    perfectFor: "مثالي لـ:",
    individualsAndFamilies: "الأفراد والعائلات",
    freelancersAndConsultants: "المستقلون والمستشارون",
    smallServiceProviders: "مقدمو الخدمات الصغار",
    keyFeatures: "المميزات الرئيسية:",
    incomeTracking: "تتبع الدخل",
    expenseLogging: "تسجيل المصروفات",
    multipleCashbooks: "دفاتر نقدية متعددة",
    smartAnalytics: "تحليلات ذكية",
    cloudBackup: "نسخ احتياطي سحابي",
    reportsAndExport: "تقارير وتصدير",
    imsMode: "وضع IMS / POS",
    imsSubtitle: "إدارة المخزون ونقاط البيع",
    imsDescription: "حل أعمال متكامل للمتاجر وتجار الجملة والموزعين. إدارة المخزون والعملاء والموردين والمبيعات — كل ذلك في مكان واحد.",
    retailShops: "متاجر التجزئة",
    wholesalers: "تجار الجملة والموزعون",
    smbBusinesses: "الشركات الصغيرة والمتوسطة",
    productCatalog: "كتالوج المنتجات",
    customerLedger: "دفتر العملاء",
    vendorManagement: "إدارة الموردين",
    invoiceGeneration: "إنشاء الفواتير",
    paymentReminders: "تذكيرات الدفع",
    smartPricing: "التسعير الذكي",
    switchModesNote: "لست متأكداً أي وضع يناسبك؟ لا تقلق — يمكنك التبديل بين الأوضاع في أي وقت!",
    exploreAllFeatures: "استكشف جميع المميزات",
    imsHighlightsTitle: "ميزات IMS قوية — مجانية بالكامل",
    imsHighlightsDescription: "تدير عملاً تجارياً؟ FINO يمنحك ميزات بمستوى المؤسسات بدون سعر المؤسسات.",
    paymentRemindersDesc: "لا تفوت أي دفعة. احصل على إشعارات عندما يدين لك العملاء بالمال.",
    smartPricingDesc: "اقتراحات أسعار تلقائية بناءً على تاريخ الشراء وهوامش الربح.",
    batchTracking: "تتبع الدفعات",
    batchTrackingDesc: "تتبع المنتجات دفعة بدفعة مع أسعار الشراء وتواريخ الانتهاء.",
    expiryAlerts: "تنبيهات الانتهاء",
    expiryAlertsDesc: "احصل على إشعارات قبل انتهاء صلاحية المنتجات. لا مزيد من الخسائر من المخزون المنتهي.",
    professionalInvoices: "فواتير احترافية",
    professionalInvoicesDesc: "إنشاء فواتير PDF بشعارك. شاركها فوراً عبر واتساب.",
    customerLedgers: "دفاتر العملاء",
    customerLedgersDesc: "سجل معاملات كامل لكل عميل. تتبع المستحقات بسهولة.",
    vendorManagementDesc: "إدارة الموردين، تتبع المستحقات، والحفاظ على علاقات صحية.",
    profitReports: "تقارير الأرباح",
    profitReportsDesc: "تحليل أرباح لكل منتج. اعرف بالضبط أي المنتجات تحقق لك المال.",
    everythingYouNeedTitle: "كل ما تحتاجه — ولا شيء لا تحتاجه",
    everythingYouNeedDescription: "بنينا FINO ليكون قوياً وبسيطاً. لا ميزات مربكة، لا تعقيد غير ضروري.",
    smartFinancialTracking: "تتبع مالي ذكي",
    smartFinancialTrackingDesc: "تتبع الدخل والمصروفات والمبيعات والمشتريات مع تحليلات قوية للاستخدام الشخصي والتجاري.",
    powerfulAnalytics: "تحليلات قوية",
    powerfulAnalyticsDesc: "احصل على رؤى مفصلة مع تقارير الأرباح واتجاهات المبيعات وأنماط الإنفاق لاتخاذ قرارات أذكى.",
    bankLevelSecurity: "أمان بمستوى البنوك",
    bankLevelSecurityDesc: "بياناتك المالية محمية بتشفير على مستوى المؤسسات. خصوصيتك هي أولويتنا القصوى.",
    accessAnywhere: "الوصول من أي مكان",
    accessAnywhereDesc: "المزامنة السحابية تبقي بياناتك متاحة على أي جهاز. اعمل من المنزل أو المتجر أو أثناء التنقل.",
    testimonialsTitle: "موثوق من الشركات والأفراد",
    testimonialsDescription: "اكتشف لماذا يحب الناس استخدام FINO لإدارة أموالهم",
    ctaTitle: "هل أنت مستعد للسيطرة؟",
    ctaDescription: "انضم إلى آلاف المستخدمين الذين يثقون في FINO لأموالهم الشخصية والتجارية. مجاني 100% — لا رسوم خفية، لا خطط مدفوعة.",
    startFreeToday: "ابدأ مجاناً اليوم",
    learnMoreAboutUs: "اعرف المزيد عنا",
  },

  // Features page
  features: {
    heroTag: "جميع المميزات — مجاني 100%",
    heroTitle: "ميزات قوية",
    heroTitleHighlight: "للتحكم الكامل",
    heroDescription: "FINO يقدم وضعين — دفتر النقد للمالية الشخصية و IMS للعمليات التجارية. اختر ما يناسب احتياجاتك، أو استخدم كليهما!",
    cashbookModeTitle: "وضع دفتر النقد",
    cashbookModeSubtitle: "مثالي لتتبع المالية الشخصية",
    cashbookModeDescription: "مثالي للأفراد والمستقلين والأسر. تتبع دخلك ومصروفاتك بدون أي تعقيد. بسيط ونظيف وفعال.",
    incomeExpenseTracking: "تتبع الدخل والمصروفات",
    incomeExpenseTrackingDesc: "سجل دخلك ومصروفاتك اليومية بسهولة. نماذج إدخال سريعة وتصنيف يجعل التتبع سهلاً.",
    multipleCashbooksTitle: "دفاتر نقدية متعددة",
    multipleCashbooksDesc: "أنشئ دفاتر نقدية منفصلة لأغراض مختلفة — شخصية، تجارية، منزلية، أو مشاريع. حافظ على تنظيم كل شيء.",
    smartAnalyticsTitle: "تحليلات ذكية",
    smartAnalyticsDesc: "تصور عادات إنفاقك مع رسوم بيانية تفاعلية. حدد الاتجاهات واتخذ قرارات مالية مبنية على البيانات.",
    budgetPlanning: "تخطيط الميزانية",
    budgetPlanningDesc: "حدد ميزانيات لفئات مختلفة وتتبع تقدمك. ابقَ ضمن حدود إنفاقك بسهولة.",
    quickEntry: "إدخال سريع",
    quickEntryDesc: "أضف المعاملات في ثوانٍ مع واجهتنا المبسطة. مصمم للسرعة والبساطة.",
    detailedReports: "تقارير مفصلة",
    detailedReportsDesc: "أنشئ تقارير مالية شاملة للاستخدام الشخصي أو الضريبي. تصدير بصيغ متعددة.",
    imsModeTitle: "وضع IMS / POS",
    imsModeSubtitle: "إدارة المخزون ونقاط البيع",
    imsModeDescription: "حل أعمال متكامل لمتاجر التجزئة وتجار الجملة والموزعين. أدر عملك بالكامل — منتجات، عملاء، موردين، فواتير، والمزيد — كل ذلك في مكان واحد.",
    productCatalogTitle: "كتالوج المنتجات",
    productCatalogDesc: "أدر مخزون منتجاتك الكامل مع فئات ورموز SKU وباركود وصور. تتبع مستويات المخزون في الوقت الفعلي.",
    customerLedgerTitle: "دفتر العملاء",
    customerLedgerDesc: "احتفظ بدفاتر مفصلة لكل عميل. تتبع المستحقات والمدفوعات وسجل المعاملات الكامل. لا تنسَ أبداً من يدين لك بالمال.",
    vendorManagementTitle: "إدارة الموردين",
    vendorManagementDesc: "أدر مورديك بكفاءة. تتبع المستحقات وتاريخ المشتريات وحافظ على علاقات صحية مع الموردين.",
    invoiceGenerationTitle: "إنشاء الفواتير",
    invoiceGenerationDesc: "أنشئ فواتير PDF احترافية بشعار عملك. شاركها فوراً عبر واتساب أو البريد الإلكتروني. تتبع حالة الدفع.",
    paymentRemindersTitle: "تذكيرات الدفع",
    paymentRemindersDesc: "عيّن تذكيرات لمستحقات العملاء ومدفوعات الموردين. احصل على إشعارات قبل مواعيد الدفع. لا تفوت تحصيل المال أبداً.",
    smartPricingTitle: "التسعير الذكي",
    smartPricingDesc: "اقتراحات أسعار تلقائية بناءً على تاريخ مشترياتك. اعرف هوامش ربحك قبل البيع. اتخذ قرارات تسعير أذكى.",
    batchTrackingTitle: "تتبع الدفعات",
    batchTrackingDesc: "تتبع المنتجات دفعة بدفعة مع أسعار شراء فردية. اعرف بالضبط أي دفعة تبيعها وبأي تكلفة.",
    postingQueue: "قائمة الترحيل",
    postingQueueDesc: "راجع واعتمد قيود الدفتر قبل الترحيل النهائي. امنع الأخطاء مع عملية تحقق من خطوتين.",
    expiryAlertsTitle: "تنبيهات الانتهاء",
    expiryAlertsDesc: "احصل على إشعارات قبل انتهاء صلاحية المنتجات. حدد أيام التنبيه لكل منتج. لا مزيد من الخسائر من المخزون المنتهي أو القريب من الانتهاء.",
    stockManagement: "إدارة المخزون",
    stockManagementDesc: "اضبط المخزون للتلف والمرتجعات أو عدم التطابق. تتبع حركات المخزون بسجل مفصل. حافظ على مخزون دقيق.",
    categoriesAndGroups: "الفئات والمجموعات",
    categoriesAndGroupsDesc: "نظم المنتجات في فئات. جمّع العملاء والموردين لإدارة وتقارير أفضل.",
    profitReportsTitle: "تقارير الأرباح",
    profitReportsDesc: "تحليل أرباح لكل منتج مع حساب أساس التكلفة. اعرف بالضبط أي المنتجات تحقق لك المال.",
    availableInBothModes: "متوفر في كلا الوضعين",
    availableInBothModesDesc: "هذه الميزات الأساسية متاحة بغض النظر عن الوضع الذي تختاره. الأمان والمزامنة والراحة — مدمجة في كل ما نبنيه.",
    cloudSync: "المزامنة السحابية",
    cloudSyncDesc: "الوصول إلى بياناتك المالية من أي مكان وفي أي وقت. النسخ الاحتياطي السحابي التلقائي يضمن عدم فقدان بياناتك أبداً.",
    secureStorage: "تخزين آمن",
    secureStorageDesc: "تشفير بمستوى البنوك يحمي معلوماتك المالية الحساسة. أمان بياناتك هو أولويتنا القصوى.",
    privacyFirst: "الخصوصية أولاً",
    privacyFirstDesc: "بياناتك ملكك. لا نشارك أو نبيع معلوماتك المالية الشخصية لأطراف ثالثة أبداً.",
    recurringTransactions: "المعاملات المتكررة",
    recurringTransactionsDesc: "أتمتة الدخل والمصروفات المتكررة. إعداد الاشتراكات والرواتب والمدفوعات المنتظمة مرة واحدة.",
    multiUserSupport: "دعم متعدد المستخدمين",
    multiUserSupportDesc: "مثالي للفرق والشركات. شارك الوصول مع أعضاء الفريق وتعاون في الإدارة المالية.",
    smartNotifications: "إشعارات ذكية",
    smartNotificationsDesc: "احصل على تنبيهات للإنفاق غير المعتاد وتذكيرات الفواتير وتحذيرات الميزانية للبقاء على اطلاع بأموالك.",
    whyFreeTitle: "لماذا FINO مجاني؟",
    whyFreeDescription: "نؤمن بأن الجميع يستحق الوصول إلى أدوات مالية قوية. سواء كنت تدير متجراً صغيراً في باكستان أو تدير مصاريف المنزل — لا ينبغي أن تدفع مقابل الإدارة المالية الأساسية. لهذا FINO مجاني وسيبقى مجاناً دائماً للاستخدام الشخصي والتجاري الصغير.",
    whyFreeSubtext: "لا رسوم خفية. لا خطط مدفوعة. لا قفل للميزات. فقط سجل واستخدم كل شيء.",
  },

  // Pricing page
  pricing: {
    heroTag: "كلا الوضعين مضمنان",
    heroTitle: "أسعار FINO —",
    heroTitleHighlight: "مجاني 100%",
    heroSubtitle: "لا رسوم خفية. لا حدود. لا مفاجآت.",
    heroDescription: "سواء استخدمت وضع دفتر النقد للمالية الشخصية أو وضع IMS لعملك — كل شيء مجاني تماماً. للأبد.",
    cashbookMode: "وضع دفتر النقد",
    freeForever: "مجاني للأبد",
    cashbookDescription: "تتبع المالية الشخصية للأفراد والمستقلين والأسر.",
    imsMode: "وضع IMS / POS",
    imsDescription: "حل أعمال متكامل للمتاجر وتجار الجملة والموزعين.",
    getStartedForFree: "ابدأ مجاناً",
    noCreditCard: "لا حاجة لبطاقة ائتمان. يمكنك التبديل بين الأوضاع في أي وقت.",
    whyFreeTitle: "لماذا FINO مجاني؟",
    whyFreeDescription: "نؤمن بأن الجميع يستحق الوصول إلى أدوات مالية قوية. سواء كنت تدير متجراً صغيراً أو تدير مصاريف المنزل — لا ينبغي أن تدفع مقابل الإدارة المالية الأساسية. لهذا FINO مجاني وسيبقى مجاناً دائماً للاستخدام الشخصي والتجاري الصغير.",
    futureUpdates: "التحديثات المستقبلية:",
    futureUpdatesDesc: "سيتم إبلاغك مسبقاً بأي تغييرات في الأسعار أو الميزات. ثقتك والشفافية مهمتان لنا.",
    unlimitedTransactions: "معاملات غير محدودة",
    multipleCashbooks: "دفاتر نقدية متعددة",
    smartAnalyticsReports: "تحليلات وتقارير ذكية",
    cloudSyncDevices: "مزامنة سحابية عبر الأجهزة",
    budgetPlanning: "تخطيط الميزانية",
    exportPdfExcel: "تصدير إلى PDF/Excel",
    unlimitedProducts: "منتجات ومخزون غير محدود",
    customerVendorLedgers: "دفاتر العملاء والموردين",
    invoiceWithLogo: "إنشاء فواتير بالشعار",
    paymentReminders: "تذكيرات الدفع",
    smartPricingSuggestions: "اقتراحات التسعير الذكي",
    batchTrackingExpiry: "تتبع الدفعات وتنبيهات الانتهاء",
    postingQueueSystem: "نظام قائمة الترحيل",
    profitLossReports: "تقارير الأرباح والخسائر",
  },

  // About page
  about: {
    heroTitle: "عن",
    heroDescription: "تطبيقان قويان في واحد — تتبع المالية الشخصية وإدارة الأعمال الكاملة، مبني للجميع.",
    ourStoryTitle: "قصتنا",
    ourStoryP1: "ولد FINO من إحباط بسيط: إدارة الأموال لا ينبغي أن تكون معقدة. في عام 2023، كافح مؤسسنا جبران آصف للعثور على أداة بسيطة لكنها قوية لتتبع مصاريف عمله دون تعقيد برامج المحاسبة التقليدية.",
    ourStoryP2: "ما بدأ كمشروع شخصي نما بسرعة إلى شيء أكبر. الأصدقاء الذين يديرون متاجر صغيرة طلبوا إدارة المخزون. أفراد العائلة أرادوا تتبع المصاريف. استمعنا للجميع — وبنينا FINO لحل كلتا المشكلتين.",
    ourStoryP3: "لهذا السبب يحتوي FINO على وضعين:",
    cashbookModeBullet: "وضع دفتر النقد — للأفراد والمستقلين والأسر الذين يريدون تتبع دخلهم ومصروفاتهم اليومية بدون أي تعقيد.",
    imsModeBullet: "وضع IMS (نظام إدارة المخزون) — لأصحاب المتاجر وتجار الجملة والموزعين الذين يحتاجون إلى إدارة المنتجات والعملاء والموردين والفواتير.",
    ourStoryP4: "اليوم، يساعد FINO آلاف الأفراد والشركات في جدة والمملكة العربية السعودية وخارجها على التحكم في أموالهم. مهمتنا لم تتغير: جعل الإدارة المالية متاحة وبسيطة وقوية للجميع —",
    completelyFree: "مجاني تماماً",
    whoIsFinoFor: "لمن FINO؟",
    whoIsFinoForDesc: "سواء كنت تدير مصاريف المنزل أو تدير إمبراطورية تجزئة، FINO لديه وضع لك.",
    cashbookModeTitle: "وضع دفتر النقد",
    personalFinance: "المالية الشخصية",
    cashbookShortDesc: "بسيط ونظيف ومركز على ما يهم — تتبع أموالك.",
    individualsAndFamilies: "الأفراد والعائلات",
    individualsDesc: "تتبع مصاريف المنزل، خطط الميزانيات، ووفر المزيد",
    freelancersAndConsultants: "المستقلون والمستشارون",
    freelancersDesc: "راقب الدخل من عملاء متعددين وتتبع المصاريف",
    households: "الأسر",
    householdsDesc: "أدر ميزانيات العائلة وتتبع كل روبية تنفقها",
    imsModeTitle: "وضع IMS / POS",
    businessManagement: "إدارة الأعمال",
    imsShortDesc: "حل أعمال متكامل — منتجات، عملاء، موردين، وفواتير.",
    retailShops: "متاجر التجزئة",
    retailDesc: "إدارة المخزون، إنشاء الفواتير، تتبع مستحقات العملاء",
    wholesalers: "تجار الجملة والموزعون",
    wholesalersDesc: "التعامل مع المخزون بالجملة، إدارة الموردين، تتبع الدفعات",
    smbBusinesses: "الشركات الصغيرة والمتوسطة",
    smbDesc: "عمليات تجارية كاملة مع تتبع الأرباح",
    ourMission: "مهمتنا",
    ourMissionDesc: "تمكين الجميع — من الأسر إلى الشركات — بأدوات إدارة مالية بسيطة وقوية ومجانية.",
    ourVision: "رؤيتنا",
    ourVisionDesc: "عالم تكون فيه الوضوح المالي متاحاً للجميع في كل مكان — بغض النظر عن حجم محفظتك أو عملك.",
    ourValues: "قيمنا",
    ourValuesDesc: "البساطة أولاً، الأمان دائماً، ونهج يضع العميل في المقام الأول في كل ما نبنيه.",
    whyFreeTitle: "لماذا FINO مجاني؟",
    whyFreeP1: "نؤمن بأن إدارة أموالك لا ينبغي أن تكلفك مالاً. سواء كنتِ ربة منزل تتتبعين مصاريف البقالة أو صاحب متجر يدير آلاف المنتجات — تستحق أدوات تعمل بدون أن تثقل جيبك.",
    whyFreeP2: "معظم التطبيقات المالية تفرض رسوماً شهرية أو تقفل ميزات مهمة خلف الجدار المدفوع. نعتقد أن ذلك غير عادل، خاصة للشركات الصغيرة والأفراد الذين يحتاجون هذه الأدوات أكثر من غيرهم.",
    whyFreeP3: "FINO مختلف. كل شيء مجاني. لا خطط مدفوعة. لا رسوم خفية. لا قفل للميزات. فقط سجل واستخدم كل شيء — وضع دفتر النقد، وضع IMS، جميع الميزات، للأبد.",
    whyFreeTagline: "لأن الحرية المالية يجب أن تكون مجانية.",
    meetOurTeam: "تعرف على فريقنا",
    meetOurTeamDesc: "الأشخاص المتحمسون وراء FINO",
    founderCeo: "المؤسس والرئيس التنفيذي",
    coFounderCmo: "المؤسس المشارك ومدير التسويق",
    coFounderCfo: "المؤسس المشارك والمدير المالي",
  },

  // Blog page
  blog: {
    heroTitle: "FINO",
    heroTitleHighlight: "المدوّنة",
    heroDescription: "نصائح للمالية الشخصية وإدارة المخزون وتحديثات المنتج ورؤى لمساعدتك في إدارة أموالك وعملك بشكل أفضل",
    featured: "مميز",
    featuredTitle: "وضعان، تطبيق واحد قوي",
    featuredDescription: "FINO يقدم وضع دفتر النقد للمالية الشخصية ووضع IMS لإدارة الأعمال الكاملة. تعلم كيف تستخدم كل وضع للتحكم في أموالك.",
    exploreFeatures: "استكشف جميع المميزات",
    cashbook: "دفتر النقد",
    personalFinance: "المالية الشخصية",
    imsPOS: "IMS / POS",
    businessManagement: "إدارة الأعمال",
    readMore: "اقرأ المزيد",
  },

  // Contact page
  contact: {
    heroTitle: "تواصل",
    heroTitleHighlight: "معنا",
    heroDescription: "هل لديك أسئلة؟ يسعدنا أن نسمع منك. أرسل لنا رسالة وسنرد في أقرب وقت ممكن.",
    sendMessage: "أرسل لنا رسالة",
    formDescription: "املأ النموذج أدناه وسنرد عليك خلال 24 ساعة",
    nameLabel: "الاسم",
    namePlaceholder: "اسمك",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "your@email.com",
    subjectLabel: "الموضوع",
    subjectPlaceholder: "كيف يمكننا مساعدتك؟",
    messageLabel: "الرسالة",
    messagePlaceholder: "أخبرنا المزيد عن استفسارك...",
    sendButton: "إرسال الرسالة",
    sending: "جارٍ الإرسال...",
    emailTitle: "البريد الإلكتروني",
    locationTitle: "الموقع",
    followUs: "تابعنا",
    messageSentTitle: "تم إرسال الرسالة!",
    messageSentDesc: "سنرد عليك في أقرب وقت ممكن.",
    validationError: "خطأ في التحقق",
  },

  // Download page
  download: {
    heroTag: "متوفر الآن على Google Play",
    heroTitle: "حمّل تطبيق FINO",
    heroDescription: "أدر أموالك أثناء التنقل مع تطبيق FINO القوي. سريع وآمن وسهل الاستخدام. تم إصداره رسمياً الآن على Google Play Store!",
    getOnGooglePlay: "احصل على FINO من Google Play",
    whyDownload: "لماذا تحمّل FINO؟",
    whyDownloadDesc: "كل ما تحتاجه للإدارة المالية",
    lightningFast: "سريع كالبرق",
    lightningFastDesc: "أداء محسّن لعمليات مالية سلسة",
    bankLevelSecurity: "أمان بمستوى البنوك",
    bankLevelSecurityDesc: "بياناتك مشفرة ومحمية في جميع الأوقات",
    offlineAccess: "وصول بدون إنترنت",
    offlineAccessDesc: "اعمل بدون إنترنت، وزامن عند الاتصال",
    realtimeSync: "مزامنة في الوقت الفعلي",
    realtimeSyncDesc: "مزامنة تلقائية عبر جميع أجهزتك",
    dataBackup: "نسخ احتياطي للبيانات",
    dataBackupDesc: "لا تفقد سجلاتك المالية أبداً مع النسخ الاحتياطي السحابي",
    multiBusiness: "أعمال متعددة",
    multiBusinessDesc: "أدر أعمالاً متعددة من تطبيق واحد",
    howToInstall: "كيفية التثبيت",
    howToInstallDesc: "اتبع هذه الخطوات البسيطة",
    step1Title: "تفعيل المصادر غير المعروفة",
    step1Desc: "اذهب إلى الإعدادات → الأمان → فعّل 'التثبيت من مصادر غير معروفة' أو 'تثبيت تطبيقات غير معروفة'",
    step2Title: "حمّل ملف APK",
    step2Desc: "اضغط على زر التحميل أعلاه للحصول على ملف FINO APK على جهازك",
    step3Title: "ثبّت التطبيق",
    step3Desc: "افتح ملف APK المحمّل واضغط 'تثبيت'. اتبع التعليمات على الشاشة",
    step4Title: "افتح وسجل الدخول",
    step4Desc: "شغّل FINO من درج التطبيقات وسجل الدخول ببيانات حسابك",
    systemRequirements: "متطلبات النظام",
    systemRequirementsDesc: "تأكد من توافق جهازك",
    minimumRequirements: "الحد الأدنى من المتطلبات",
    operatingSystem: "نظام التشغيل",
    operatingSystemValue: "Android 5.0 (Lollipop) أو أعلى",
    storageSpace: "مساحة التخزين",
    storageSpaceValue: "50 ميجابايت مساحة حرة",
    ram: "الذاكرة العشوائية",
    ramValue: "1 جيجابايت أو أكثر",
    internetConnection: "اتصال الإنترنت",
    internetConnectionValue: "مطلوب للمزامنة (اختياري للاستخدام دون اتصال)",
    faq: "الأسئلة الشائعة",
    faqDesc: "كل ما تحتاج معرفته",
    faq1Q: "هل من الآمن تثبيت ملفات APK؟",
    faq1A: "نعم، ملف APK الخاص بـ FINO آمن تماماً. نستخدم إجراءات أمان بمستوى البنوك وملف APK موقّع بشهادتنا الرسمية. ومع ذلك، قم دائماً بتحميل APK من المصادر الرسمية فقط لضمان الأمان.",
    faq2Q: "لماذا FINO غير موجود على Google Play Store؟",
    faq2A: "FINO حالياً في مرحلة الاختبار التجريبي. نجمع ملاحظات المستخدمين ونجري تحسينات قبل الإطلاق الرسمي على Play Store. التوزيع المباشر لـ APK يسمح لنا بتقديم تحديثات وميزات جديدة أسرع.",
    faq3Q: "كيف أحدّث التطبيق؟",
    faq3A: "ستتلقى إشعاراً داخل التطبيق عند توفر إصدار جديد. ببساطة حمّل أحدث APK من هذه الصفحة وثبّته فوق الإصدار الحالي. سيتم الحفاظ على بياناتك أثناء التحديث.",
    faq4Q: "ماذا لو فشل التثبيت؟",
    faq4A: "إذا فشل التثبيت، تأكد من تفعيل 'التثبيت من مصادر غير معروفة' في إعدادات جهازك. تحقق أيضاً من توفر مساحة تخزين كافية. إذا استمرت المشاكل، حاول إعادة تشغيل جهازك أو تواصل مع فريق الدعم.",
    faq5Q: "هل ستتم مزامنة بياناتي بين الويب والموبايل؟",
    faq5A: "نعم! FINO يزامن جميع بياناتك تلقائياً عبر منصات الويب والموبايل في الوقت الفعلي. أي تغييرات تجريها على جهاز واحد ستظهر فوراً على جميع أجهزتك الأخرى عند الاتصال بالإنترنت.",
    faq6Q: "هل يمكنني استخدام FINO بدون اتصال؟",
    faq6A: "بالتأكيد! FINO يعمل بدون اتصال ويخزن جميع بياناتك محلياً. عند إعادة الاتصال بالإنترنت، ستتم مزامنة جميع تغييراتك تلقائياً مع السحابة وعبر جميع أجهزتك.",
    readyTitle: "هل أنت مستعد للبدء؟",
    readyDescription: "حمّل FINO الآن وتحكم في أموالك في أي مكان وأي وقت.",
    downloadFromGooglePlay: "تحميل من Google Play",
  },

  // Auth page
  auth: {
    fino: "FINO",
    financialPlatform: "منصتك لإدارة الأموال",
    welcome: "مرحباً",
    signInOrSignUp: "سجل الدخول إلى حسابك أو أنشئ حساباً جديداً",
    signIn: "تسجيل الدخول",
    signUp: "إنشاء حساب",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "you@example.com",
    passwordLabel: "كلمة المرور",
    passwordPlaceholder: "••••••••",
    confirmPassword: "تأكيد كلمة المرور",
    rememberMe: "تذكرني على هذا الجهاز",
    signingIn: "جارٍ تسجيل الدخول...",
    signInButton: "تسجيل الدخول",
    forgotPassword: "نسيت كلمة المرور؟",
    orContinueWith: "أو تابع مع",
    continueWithGoogle: "المتابعة مع Google",
    fullName: "الاسم الكامل *",
    fullNamePlaceholder: "محمد أحمد",
    password: "كلمة المرور *",
    passwordStrength: "قوة كلمة المرور:",
    weak: "ضعيفة",
    medium: "متوسطة",
    strong: "قوية",
    optionalInfo: "معلومات اختيارية",
    whatBringsYou: "ما الذي أتى بك إلى هنا؟",
    selectPurpose: "اختر غرضك",
    manageBusiness: "إدارة الأعمال",
    householdExpenses: "مصاريف المنزل",
    personalFinance: "المالية الشخصية",
    freelanceWork: "عمل مستقل",
    other: "أخرى",
    country: "البلد",
    countryPlaceholder: "باكستان",
    city: "المدينة",
    cityPlaceholder: "كراتشي",
    phoneNumber: "رقم الهاتف",
    phonePlaceholder: "+92 300 1234567",
    dateOfBirth: "تاريخ الميلاد",
    creatingAccount: "جارٍ إنشاء الحساب...",
    createAccount: "إنشاء حساب",
    uploadPhoto: "رفع صورة (اختياري)",
    termsAgreement: "بالمتابعة، أنت توافق على شروط الخدمة وسياسة الخصوصية",
    verificationCodeSent: "تم إرسال رمز التحقق",
    verificationCodeDesc: "تحقق من بريدك الإلكتروني للحصول على رمز تحقق مكون من 6 أرقام",
    accountCreated: "تم إنشاء الحساب!",
    accountCreatedDesc: "يرجى التحقق من بريدك الإلكتروني. تحقق من صندوق الوارد للحصول على رمز تحقق مكون من 6 أرقام.",
  },

  // Settings page
  settings: {
    title: "الإعدادات",
    subtitle: "إدارة حسابك وتفضيلاتك",
    profile: "الملف الشخصي",
    security: "الأمان",
    preferences: "التفضيلات",
    prefs: "تفضيلات",
    backup: "النسخ الاحتياطي",
    personalInfo: "المعلومات الشخصية",
    personalInfoDesc: "تحديث تفاصيلك الشخصية وتفضيلاتك",
    dangerZone: "منطقة الخطر",
    dangerZoneDesc: "إجراءات لا يمكن التراجع عنها تؤثر على حسابك",
    deleteAccount: "حذف الحساب",
    deleteAccountDesc: "حذف حسابك وجميع البيانات المرتبطة نهائياً",
    loadingSettings: "جارٍ تحميل الإعدادات...",
  },

  // Preferences
  preferences: {
    themeAndAppearance: "المظهر والشكل",
    themeAndAppearanceDesc: "خصص مظهر التطبيق",
    theme: "المظهر",
    light: "فاتح",
    dark: "داكن",
    system: "النظام",
    appMode: "وضع التطبيق",
    appModeDesc: "اختر بين دفتر النقد البسيط أو نظام إدارة المخزون",
    currentMode: "الوضع الحالي",
    cashbook: "دفتر النقد",
    ims: "IMS",
    imsDescription: "إدارة مخزون متقدمة مع منتجات وعملاء وموردين ودفاتر",
    cashbookDescription: "تتبع بسيط للدخل والمصروفات لعملك",
    switchModeNote: "يمكنك تبديل الأوضاع في أي وقت. سيتم الحفاظ على بياناتك.",
    switchedToIms: "تم التبديل إلى وضع IMS",
    switchedToCashbook: "تم التبديل إلى وضع دفتر النقد",
    nowUsingIms: "الآن تستخدم نظام إدارة المخزون",
    nowUsingCashbook: "الآن تستخدم دفتر النقد البسيط",
    preferenceUpdated: "تم تحديث التفضيل",
    businessSettings: "إعدادات العمل",
    businessSettingsDesc: "إدارة شعار عملك ومعلوماته للفواتير",
    businessLogo: "شعار العمل",
    businessLogoUploadDesc: "ارفع شعار عملك ليظهر على جميع الفواتير وتقارير الدفتر",
    uploading: "جارٍ الرفع...",
    businessName: "اسم العمل",
    businessNamePlaceholder: "أدخل اسم عملك",
    contactInfo: "معلومات الاتصال",
    contactInfoPlaceholder: "هاتف، بريد إلكتروني، عنوان، إلخ.",
    contactInfoDesc: "ستظهر هذه المعلومات على الفواتير والتقارير",
    noOrganization: "لم يتم العثور على مؤسسة",
    financialSettings: "الإعدادات المالية",
    financialSettingsDesc: "تحديد كيفية عرض الأرقام والتواريخ",
    numberFormat: "تنسيق الأرقام",
    commaFormat: "فاصلة (1,234.56)",
    standardFormat: "التنسيق القياسي",
    dotFormat: "نقطة (1.234,56)",
    europeanFormat: "التنسيق الأوروبي",
    spaceFormat: "مسافة (1 234.56)",
    internationalFormat: "التنسيق الدولي",
    dateFormat: "تنسيق التاريخ",
    securitySettings: "إعدادات الأمان",
    securitySettingsDesc: "إدارة تفضيلات أمان حسابك",
    autoLogoutTimer: "مؤقت تسجيل الخروج التلقائي",
    minutes15: "15 دقيقة",
    minutes30: "30 دقيقة",
    hour1: "ساعة واحدة",
    hours2: "ساعتان",
    never: "أبداً",
    autoLogoutDesc: "تسجيل خروج تلقائي بعد فترة من عدم النشاط",
    stayLoggedIn: "البقاء مسجل الدخول",
    stayLoggedInDesc: "إبقائي مسجل الدخول عبر جلسات المتصفح",
    postingChanges: "تغييرات الترحيل",
    postingChangesDesc: "التحكم في كيفية ترحيل التغييرات إلى الدفتر",
    postingChangesQuestion: "هل تريد مراجعة وإعادة ترحيل كل تغيير في البيانات؟",
    checkAndPost: "نعم، أريد مراجعة وترحيل التغييرات",
    checkAndPostDesc: "مراجعة جميع التغييرات قبل ترحيلها إلى الدفتر",
    directToLedger: "لا، ترحيل مباشر إلى الدفتر",
    directToLedgerDesc: "يتم ترحيل التغييرات تلقائياً بدون مراجعة",
    transactionDefaults: "الافتراضيات للمعاملات",
    transactionDefaultsDesc: "تعيين القيم الافتراضية للمعاملات الجديدة",
    defaultTransactionType: "نوع المعاملة الافتراضي",
    cashIn: "نقد داخل (دخل)",
    cashOut: "نقد خارج (مصروف)",
    defaultPaymentMethod: "طريقة الدفع الافتراضية",
    cash: "نقداً",
    online: "عبر الإنترنت",
    language: "اللغة",
    languageDesc: "تغيير لغة التطبيق",
    english: "English",
    arabic: "العربية (Arabic)",
  },

  // Module Selection
  moduleSelection: {
    badge: "نظام إدارة الأعمال",
    title: "مرحباً في FINO",
    subtitle: "اختر وحدتك للبدء. يمكنك التبديل بين الوحدات في أي وقت من لوحة التحكم.",
    cashbook: "دفتر النقد",
    cashbookDesc: "تتبع دخلك ومصروفاتك اليومية بسهولة",
    cashbookFeature1: "تسجيل معاملات الدخل والمصروفات",
    cashbookFeature2: "دفاتر نقدية متعددة لأعمال مختلفة",
    cashbookFeature3: "إنشاء تقارير وملخصات شهرية",
    cashbookFeature4: "تصدير البيانات إلى Excel/PDF",
    openCashbook: "فتح دفتر النقد",
    inventoryManagement: "إدارة المخزون",
    inventoryDesc: "نظام إدارة أعمال متكامل",
    imsFeature1: "إدارة المنتجات والفئات والمخزون",
    imsFeature2: "إدارة الموردين والعملاء",
    imsFeature3: "إنشاء فواتير وتتبع المدفوعات",
    imsFeature4: "دفاتر مفصلة وتقارير مالية",
    openInventory: "فتح المخزون",
    opening: "جارٍ الفتح...",
    footerNote: "يمكنك الوصول إلى كلا الوحدتين في أي وقت. بياناتك مخزنة بأمان ومزامنة عبر جميع الأجهزة.",
    modeSelected: "تم اختيار الوضع",
    welcomeToMode: "مرحباً في وضع {mode}!",
  },

  // Inventory / IMS
  inventory: {
    title: "إدارة المخزون",
    dashboard: "لوحة التحكم",
    products: "المنتجات",
    stockManagement: "إدارة المخزون",
    customers: "العملاء",
    vendors: "الموردون",
    analytics: "التحليلات",
    reports: "التقارير",
    reminders: "التذكيرات",
    history: "السجل",
    management: "الإدارة",
    goodMorning: "صباح الخير",
    goodAfternoon: "مساء الخير",
    goodEvening: "مساء الخير",
    totalSales: "إجمالي المبيعات",
    totalProfit: "إجمالي الأرباح",
    receivables: "المستحقات",
    payables: "المدفوعات",
    stockValue: "قيمة المخزون",
    netPosition: "الوضع الصافي",
    totalProducts: "إجمالي المنتجات",
    pendingInvoices: "الفواتير المعلقة",
    lowStockAlert: "تنبيه المخزون المنخفض",
    cashInHand: "النقد في اليد",
    manageInfo: "إدارة معلومات عملائك",
    manageSupplierInfo: "إدارة معلومات مورديك",
    activityHistory: "سجل النشاط",
    activityHistoryDesc: "مراجعة جميع الإجراءات عبر المنتجات والعملاء والموردين",
    productActivity: "عرض نشاط المنتجات بما في ذلك المبيعات والمشتريات وتعديلات المخزون",
    customerActivity: "تتبع معاملات العملاء والفواتير والمدفوعات والمرتجعات",
    vendorActivity: "مراقبة أنشطة الموردين والمشتريات والمدفوعات والمرتجعات",
    recentActivities: "أنشطة حديثة",
    viewHistory: "عرض السجل",
    historyTip: "اضغط على أي فئة أعلاه لعرض السجل المفصل مع مرشحات التاريخ وأنواع الإجراءات وخيارات التصدير.",
    tip: "نصيحة:",
    analyticsDesc: "رؤى أعمال شاملة ومقاييس الأداء",
    cropBusinessLogo: "قص شعار العمل",
    addTransaction: "إضافة معاملة",
    transactionHistory: "سجل المعاملات والنظرة المالية العامة",
    totalCashIn: "إجمالي النقد الداخل",
    totalCashOut: "إجمالي النقد الخارج",
    netBalance: "الرصيد الصافي",
    recentTransactions: "المعاملات الأخيرة",
    searchTransactions: "بحث في المعاملات...",
    noTransactions: "لا توجد معاملات بعد",
    startAddingTransaction: "ابدأ بإضافة أول معاملة",
    addFirstTransaction: "إضافة أول معاملة",
    noTransactionsFound: "لم يتم العثور على معاملات",
    adjustSearchOrFilters: "حاول تعديل البحث أو المرشحات",
    clearFilters: "مسح المرشحات",
    activeFilters: "مرشحات نشطة:",
    clearAll: "مسح الكل",
    filterTransactions: "تصفية المعاملات",
    transactionType: "نوع المعاملة",
    allTypes: "جميع الأنواع",
    cashIn: "نقد داخل",
    cashOut: "نقد خارج",
    paymentMethod: "طريقة الدفع",
    allMethods: "جميع الطرق",
    applyFilters: "تطبيق المرشحات",
    finalBalance: "الرصيد النهائي",
  },

  // Business List (Cashbook)
  businessList: {
    myBusinesses: "أعمالي",
    subtitle: "إدارة محفظة أعمالك وسجلاتك المالية",
    addBusiness: "إضافة عمل",
    add: "إضافة",
    noBusinesses: "لا توجد أعمال بعد",
    noBusinessesDesc: "أنشئ أول عمل لك لبدء إدارة الأموال",
    addFirstBusiness: "أضف عملك الأول",
    deleteBusiness: "حذف العمل",
    deleteConfirm: "هل أنت متأكد أنك تريد حذف \"{name}\"؟ لا يمكن التراجع عن هذا الإجراء وسيحذف أيضاً جميع دفاتر النقد والمعاملات المرتبطة.",
  },

  // Cashbook List
  cashbookList: {
    manageCashbooks: "إدارة دفاتر النقد والسجلات المالية",
    addCashbook: "إضافة دفتر نقد",
    noCashbooks: "لا توجد دفاتر نقد بعد",
    noCashbooksDesc: "أنشئ أول دفتر نقد لبدء تسجيل المعاملات",
    addFirstCashbook: "أضف أول دفتر نقد",
    deleteCashbook: "حذف دفتر النقد",
    deleteConfirm: "هل أنت متأكد أنك تريد حذف \"{name}\"؟ لا يمكن التراجع عن هذا الإجراء وسيحذف أيضاً جميع المعاملات المرتبطة.",
  },

  // Footer
  footer: {
    quickLinks: "روابط سريعة",
    support: "الدعم",
    helpCenter: "مركز المساعدة",
    faq: "الأسئلة الشائعة",
    privacyPolicy: "سياسة الخصوصية",
    termsAndConditions: "الشروط والأحكام",
    connectWithUs: "تواصل معنا",
    emailUs: "يسعدنا أن نسمع منك!",
    logoutConfirmTitle: "تسجيل الخروج والذهاب للصفحة الرئيسية؟",
    logoutConfirmDesc: "سيتم تسجيل خروجك من حسابك وإعادة توجيهك إلى الصفحة الرئيسية.",
    yesLogout: "نعم، سجل الخروج",
  },

  // 404 page
  notFound: {
    title: "404",
    description: "عذراً! الصفحة غير موجودة",
    returnHome: "العودة للرئيسية",
  },

  // Privacy page
  privacy: {
    title: "سياسة الخصوصية",
    intro: "خصوصيتك مهمة لنا. توضح سياسة الخصوصية هذه كيف يجمع FINO معلوماتك ويستخدمها ويحميها.",
  },

  // Terms page
  terms: {
    title: "الشروط والأحكام",
    intro: "مرحباً بك في FINO! بتحميل أو الوصول إلى أو استخدام تطبيقنا وخدماتنا، فإنك توافق على الالتزام بالشروط والأحكام التالية. يرجى قراءتها بعناية.",
  },
};
